module.exports = __webpack_public_path__ + "images/graphic-footer_mobile_e2243f921ec754cc5a40e197b00ee997.png";